/* eslint-disable import/first */
import React, { useState, useRef } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;

const { selectHomeBaseURL, selectBaseURL } = Slices.configSlice;

import YoutubePlay from '../Icons/YoutubePlay';
import DialogBox from '../DialogBox';
import css from './index.module.scss';

export default function Video({ widgetData }) {
  const { media: mediaList } = widgetData;
  const imgBaseUrl = useSelector(selectHomeBaseURL);
  const fullScreenVideoRef = useRef();
  const videoUrl = useSelector(selectBaseURL);
  const [openMedia, setOpenMedia] = useState(false);

  const [video, setVideo] = useState(null);
  const handleVideo = (media) => () => {
    setOpenMedia((prev) => true);

    setVideo(media);
  };
  const handleClose = () => {
    setOpenMedia((prev) => !openMedia);
  };
  React.useEffect(() => {
    if (openMedia) {
      setTimeout(() => {
        var el = document.getElementById('full-screenVideo');
        el.requestFullscreen();
      }, 1000);
    }
  }, [openMedia]);
  return (
    <>
      <div className={css.root}>
        {mediaList.map((media) => (
          <div
            className={css.container}
            key={`media-${media.sequence}-${media.mediaUrl}`}
            onClick={handleVideo(media)}
          >
            <img className={css.thumbnail} src={`${imgBaseUrl}${media.thumb}`} alt="" />
            <div className={css.playButton}>
              <YoutubePlay src={`${imgBaseUrl}${media.mediaUrl}`} />
            </div>
          </div>
        ))}
      </div>

      {openMedia && (
        <DialogBox isOpen={openMedia} onClose={handleClose}>
          <video
            ref={fullScreenVideoRef}
            id="full-screenVideo"
            controls
            preload="auto"
            autoplay="true"
            data-object-fit="cover"
          >
            <source src={`${videoUrl.home}${video.videoUrl}`} type="video/mp4" />
          </video>
        </DialogBox>
      )}
    </>
  );
}
